import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;
const validationWla = 'wla/get-form';
const onsaveWla = 'wla/submit';
const create = 'wla/create-worker-type';
const update = 'wla/update-worker-type';
const list = 'wla/list-worker-type';
const listActivityType = 'wla/list-activity-type';
const wlaStatus = 'wla/update-status';
const createActivityType = 'wla/create-activity-type';
const updateActivityType = 'wla/update-activity-type';
// dashboard
const dashboardJobLvl = 'wla/detail-report-joblevel';
const dashboardDivision = 'wla/detail-report-board';
const dashboardOrg = 'wla/detail-report-organization';
const dashboardEmployee = 'wla/detail-report-employee';
const dashboardEmployeeRegion = 'wla/base-analytic-employee';
// status wla
const listStatus = 'wla/list';
const detailStatus = 'wla/detail';
const listRegion = 'organization/list-region';
const createRegion = 'organization/create-region';
const updateRegion = 'organization/update-region';
// limit fte
const listLimitFTE = 'wla/list-fte-limit';
const listLimitFTEPublic = 'wla/master-form/list-fte-limit';
const createLimitFTE = 'wla/create-fte-limit';
const updateLimitFTE = 'wla/update-fte-limit';
// limit fte
// export
const exportRawDataOverall = 'wla/raw-data-woverall';
const exportRawDataActivity = 'wla/raw-data-activity';
// export
// structure view personnel
const structureEmployee = 'wla/overall-structure-employee';
// chart - other category
const listOtherCategoryBoard = 'wla/list-category-board';
const listOtherCategoryDepartement = 'wla/list-category-joblevel';
const listOtherCategoryOrg = 'wla/list-category-organization';
const listOtherCategoryEmployee = 'wla/list-category-employee';
const createOtherCategory = 'wla/create-category';
const updateOtherCategory = 'wla/update-category';
const listOtherCategory = 'wla/list-category';
const listOtherCategoryPublic = 'wla/master-form/list-wla-category';
const listWlaProcess = 'wla/overall-structure-process';
// chart - other category
// wla template
const postWlaTemplate = 'wla-template/submit';
const listWlaTemplate = 'wla-template/list';
// wla template
// assessment
const postAssessment = 'wla-period/create';
// assessment
const wlaProgressSummary = 'wla/progress-summary';
const detlaiWlaProcess = 'wla-process/detail';
const detlaiWlaProcessList = 'wla-process/list-process-activity';
// barChart
const barChart = 'wla/get-bar-chart';
// detail Chart Wla Analytics
const detailOrg = 'wla/overall-structure';

export const apiValidationWLA = async (val) => {
  const datas = await http.get(`${URL_V2 + validationWla}`, {
    params: val,
  });
  return datas.data.data;
};
export const apiOnSaveWLA = async (val) => {
  const datas = await http.post(`${URL + onsaveWla}`, val);
  return datas.data;
};
export const apiWlaCreate = async (val) => {
  const datas = await http.post(`${URL + create}`, val);
  return datas.data;
};
export const apiWlaUpdate = async (val) => {
  const datas = await http.post(`${URL + update}`, val);
  return datas.data;
};
export const apiWlaList = async (val) => {
  const datas = await http.post(`${URL + list}`, val);
  return datas.data.data;
};

export const apiListActivityType = async (val) => {
  const datas = await http.post(`${URL + listActivityType}`, val);
  return datas.data.data;
};

// dashbaord
export const apiWlaDashboardJobLvl = async (val) => {
  const datas = await http.post(`${URL + dashboardJobLvl}`, val);
  return datas.data.data;
};
export const apiWlaDashboardDivision = async (val) => {
  const datas = await http.post(`${URL + dashboardDivision}`, val);
  return datas.data.data;
};
export const apiWlaDashboardEmployee = async (val) => {
  const datas = await http.post(`${URL + dashboardEmployee}`, val);
  return datas.data.data;
};
export const apiWlaDashboardOrg = async (val) => {
  const datas = await http.post(`${URL + dashboardOrg}`, val);
  return datas.data.data;
};
export const apiWlaStatus = async (val) => {
  const datas = await http.post(`${URL + wlaStatus}`, val);
  return datas.data;
};
export const apiWlaListStatus = async (val) => {
  const datas = await http.post(`${URL + listStatus}`, val);
  return datas.data.data;
};
export const apiWlaDetailStatus = async (val) => {
  const datas = await http.post(`${URL_V2 + detailStatus}`, val);
  return datas.data.data;
};
export const apiListRegion = async (val) => {
  const datas = await http.post(`${URL + listRegion}`, val);
  return datas.data.data;
};
export const apiCreateRegion = async (val) => {
  const datas = await http.post(`${URL + createRegion}`, val);
  return datas.data.data;
};
export const apiUpdateRegion = async (val) => {
  const datas = await http.post(`${URL + updateRegion}`, val);
  return datas.data.data;
};
export const apiCreateActivityType = async (val) => {
  const datas = await http.post(`${URL + createActivityType}`, val);
  return datas.data;
};
export const apiUpdateActivityType = async (val) => {
  const datas = await http.post(`${URL + updateActivityType}`, val);
  return datas.data;
};
export const apiListLimitFTE = async (val) => {
  const datas = await http.post(`${URL + listLimitFTE}`, val);

  return datas.data.data;
};
export const apiListLimitFTEPublic = async (val) => {
  const datas = await http.post(`${URL + listLimitFTEPublic}`, val);

  return datas.data.data;
};
export const apiCreateLimitFTE = async (val) => {
  const datas = await http.post(`${URL + createLimitFTE}`, val);
  return datas.data;
};
export const apiUpdateLimitFTE = async (val) => {
  const datas = await http.post(`${URL + updateLimitFTE}`, val);
  return datas.data;
};
export const apiExportDataOverall = async (val) => {
  const datas = await http.post(`${URL + exportRawDataOverall}`, val);
  return datas.data.data;
};
export const apiExportDataActivity = async (val) => {
  const datas = await http.post(`${URL + exportRawDataActivity}`, val);
  return datas.data.data;
};
export const apiStructureEmployee = async (val) => {
  const datas = await http.post(`${URL + structureEmployee}`, val);
  return datas.data.data;
};
export const apiListEmployeeRegion = async (val) => {
  const datas = await http.post(`${URL + dashboardEmployeeRegion}`, val);
  return datas.data.data;
};
export const apiBoardOtherCategory = async (val) => {
  const datas = await http.post(`${URL + listOtherCategoryBoard}`, val);
  return datas.data.data;
};
export const apiCreateOtherCategory = async (val) => {
  const datas = await http.post(`${URL + createOtherCategory}`, val);
  return datas.data;
};
export const apiUpdateOtherCategory = async (val) => {
  const datas = await http.post(`${URL + updateOtherCategory}`, val);
  return datas.data;
};
export const apiListOtherCategory = async (val) => {
  const datas = await http.post(`${URL + listOtherCategory}`, val);
  return datas.data.data;
};
export const apiListOtherCategoryPublic = async (val) => {
  const datas = await http.post(`${URL + listOtherCategoryPublic}`, val);
  return datas.data.data;
};
export const apiListOtherCategoryDepartment = async (val) => {
  const datas = await http.post(`${URL + listOtherCategoryDepartement}`, val);
  return datas.data.data;
};
export const apiListOtherCategoryOrg = async (val) => {
  const datas = await http.post(`${URL + listOtherCategoryOrg}`, val);
  return datas.data.data;
};
export const apiListOtherCategoryEmployee = async (val) => {
  const datas = await http.post(`${URL + listOtherCategoryEmployee}`, val);
  return datas.data.data;
};
export const apiPostAssessmentWLA = async (val) => {
  const datas = await http.post(`${URL + postAssessment}`, val);
  return datas.data.data;
};
export const apiPostWlaTemplate = async (val) => {
  const datas = await http.post(`${URL + postWlaTemplate}`, val);
  return datas.data.data;
};
export const apiListWlaTemplate = async (val) => {
  const datas = await http.post(`${URL + listWlaTemplate}`, val);
  return datas.data.data;
};
export const apiWlaProgressSummary = async (val) => {
  const datas = await http.post(`${URL + wlaProgressSummary}`, val);
  return datas.data.data;
};
export const apiWlaProcessChart = async (val) => {
  const datas = await http.post(`${URL + listWlaProcess}`, val);
  return datas.data.data;
};
export const apiWlaProcessDetail = async (val) => {
  const datas = await http.get(`${URL_V2 + detlaiWlaProcess}`, {
    params: val,
  });
  return datas.data.data;
};
export const apiWlaProcessList = async (processId: string) => {
  const datas = await http.get(`${URL_V2}wla-process/list-process-activity/${processId}`, {});
  return datas.data?.data !== undefined ? datas.data.data : datas.data;
};

export const apiBarChart = async (val) => {
  const datas = await http.post(`${URL + barChart}`, val);
  return datas.data.data;
};

export const apiDetailChart = async (val) => {
  const datas = await http.get(`${URL_V2 + detailOrg}?board_id=${val}`);
  return datas.data.data;
};
